export default __webpack_public_path__ + "static/media/IMG_0027_8_11zon.4c56e644.jpg";